import React from "react";
import { Col, ProgressBar, Row } from "react-bootstrap";

import {
  customerSurveyButtonConstants,
  customerSurveyConstants,
  EMPTY_ARRAY_LENGTH,
} from "../../../../constants";

const { SUBMIT, NEXT, BACK } = customerSurveyButtonConstants;
const { FULL_PROGRESS, DEFAULT_QUESTION_PAGE } = customerSurveyConstants;

const NextButton = (props) => {
  const {
    questionArray,
    handleNext,
    currentQuestion,
    handleBack,
    isDisabled,
    isNPSFirstActive,
    isFiveStarOnNPS,
    isNPSQuestion,
  } = props;

  //Determine if we should show Submit button
  //Show Submit if:
  //1. It's the last question OR
  //2. It's NPS First mode AND it's an NPS question (questionOrder === -1) AND user gave 5 stars
  const shouldShowSubmit =
    currentQuestion + 1 === questionArray?.length ||
    (isNPSFirstActive && isNPSQuestion && isFiveStarOnNPS);

  let progressBarNow =
    Array.isArray(questionArray) && questionArray.length > EMPTY_ARRAY_LENGTH
      ? ((currentQuestion + 1) / questionArray.length) * FULL_PROGRESS
      : EMPTY_ARRAY_LENGTH;

  //If NPS First mode is active and it's an NPS question, set progress bar to 100%
  if (shouldShowSubmit) {
    progressBarNow = FULL_PROGRESS;
  }

  return (
    <Row className="mt-auto px-2  justify-content-center mx-2 mb-md-1 ">
      <Col md={12}>
        <Col md={3} className="mx-auto mt-2 pb-1 px-2">
          <button
            className="text-white next-button border-0 rounded h6 cursor-disabled"
            type="submit"
            disabled={isDisabled || false}
            onClick={handleNext ?? (() => {})} //NOSONAR
          >
            {shouldShowSubmit ? SUBMIT : NEXT}
          </button>
        </Col>
      </Col>
      <Col md={12}>
        {Array.isArray(questionArray) &&
          questionArray.length > EMPTY_ARRAY_LENGTH &&
          currentQuestion !== DEFAULT_QUESTION_PAGE && (
            <Col
              md={3}
              className="mx-auto pb-1 px-2 d-flex justify-content-center"
            >
              <button
                className="back-button border-0 rounded h6 mb-0"
                type="submit"
                onClick={handleBack ?? (() => {})} //NOSONAR
                size="sm"
              >
                {BACK}
              </button>
            </Col>
          )}
      </Col>
      <Col md={12}>
        <Col md={3} className="mx-auto mt-2 pb-1 px-2">
          <ProgressBar now={progressBarNow} className="survey-progress-bar" />
        </Col>
      </Col>
    </Row>
  );
};

export default NextButton;
